import { calculateMonthlyData } from './calculateMonthlyData';

/**
 * Set data for the internal expenses chart based on intern invoices.
 * @param {Object} params - Parameters for internExpencesSetData function.
 * @param {Object} params.internInvoices - Intern invoices data grouped by year keys (N-1, N, etc.).
 * @param {Function} params.setItems - State setter for chart items.
 * @param {Function} params.t - Translation function.
 * @returns {void}
 */
export const internExpencesSetData = ({ internInvoices, setItems, t }) => {
  calculateMonthlyData({ dataByKey: internInvoices, setItems, t });
};
